require('dotenv').config()

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Authentication from './plugins/authentication'
import Chart from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import chartDrawTextPlugin from './plugins/chartjs-plugin-draw-text'
import router from './router'
import analytics from './plugins/analytics'
import { createPinia, PiniaVuePlugin } from 'pinia'

Chart.plugins.register(chartDrawTextPlugin)
Chart.plugins.register(annotationPlugin)

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(Authentication)

Vue.config.productionTip = false

new Vue({
  analytics,
  pinia,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
